import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = React.useState("checking");
  const [info, setInfo] = React.useState(null);

  React.useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/checkout/status/${sessionId}`);
        setInfo(data);
        if (data.payment_status === "paid") setStatus("paid");
        else if (data.status === "expired") setStatus("expired");
        else if (attempts < 6) setTimeout(poll, 2000);
        else setStatus("timeout");
      } catch { setStatus("error"); }
    };
    poll();
  }, [sessionId]);

  return (
    <main className="pt-32 pb-24 min-h-screen">
      <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
        {status === "checking" && (<>
          <div className="overline">Processing…</div>
          <h1 className="font-display font-light text-5xl mt-6">Confirming your payment</h1>
          <p className="text-secondary mt-6">This usually takes a few seconds.</p>
        </>)}
        {status === "paid" && (<>
          <div className="overline">Confirmed</div>
          <h1 className="font-display font-light text-6xl mt-6">Thank you.</h1>
          <p className="text-secondary mt-6 text-lg leading-relaxed">Your payment of <span className="text-brand">${((info?.amount_total||0)/100).toLocaleString()}</span> has been received. Sophia will personally reach out within one business day to kick off your project.</p>
          <Link to="/portal" className="btn-primary mt-10 inline-flex" data-testid="success-portal-cta">Open Your Portal →</Link>
        </>)}
        {(status === "expired" || status === "timeout" || status === "error") && (<>
          <div className="overline">Payment status</div>
          <h1 className="font-display font-light text-5xl mt-6">We couldn't confirm your payment.</h1>
          <p className="text-secondary mt-6">Please check your email for a Stripe receipt, or contact us if you were charged.</p>
          <Link to="/" className="btn-secondary mt-10 inline-flex">Back home</Link>
        </>)}
      </div>
    </main>
  );
}
